<template>
    <div class="page-content">
        <UserHeadline :title="$t('OrderInfo.title')" icon="info" />
        <div class="page-content__container">
            <YourOrder />
            <OrderHistory />
        </div>
    </div>
</template>

<script>
    import YourOrder from 'components/user/orderinfo/YourOrder'
    import OrderHistory from 'components/user/orderinfo/OrderHistory'
    import UserHeadline from 'components/user/UserHeadline'

    export default {
        components: {
            YourOrder,
            OrderHistory,
            UserHeadline
        }
    }
</script>

<style lang="scss" scoped>
    .page-content {
        &__container {
            display: flex;
            flex-direction: column;
            background: $alabaster;
            padding: 30px 20px;
        }
    }
</style>
